import t  from './locales';

document.addEventListener("turbolinks:load", () => {
  for (const personType of ['adult', 'child', 'senior', 'student']) {
    const peopleCountElement = document.getElementById(`order-unit-cancel-${personType}-count-select`) as HTMLSelectElement;
    if(!peopleCountElement) continue;

    peopleCountElement.addEventListener('change', (e) => onChangeCancelPeopleCount(e.target as HTMLSelectElement, personType));
  };

  const moveToConfirmationButton = document.getElementById('order-unit-cancel-confirmation-button');
  moveToConfirmationButton.addEventListener('click', () => {
    handleCancelConfirmationButtonLink();
  })
})

const onChangeCancelPeopleCount = (e: HTMLSelectElement, personType: string) => {
  const confirmationBody = document.getElementById(`order-unit-cancel-confirm-${personType}`);

  if (Number(e.value) > 0) {
    confirmationBody.style.display = 'block';
    const peopleCountElement = document.getElementById(`order-unit-cancel-confirm-${personType}-count`);
    peopleCountElement.innerHTML = t.numberOfPeople({ number: Number(e.value) });
    activateCancelConfirmationButton();
  } else {
    confirmationBody.style.display = 'none';
    handleCancelConfirmationButton();
  }
}

const activateCancelConfirmationButton = () => {
  const cancelConfirmationButton = document.getElementById('order-unit-cancel-confirmation-button');
  cancelConfirmationButton.style.pointerEvents = 'auto'
  cancelConfirmationButton.classList.remove('disabled');
}

const handleCancelConfirmationButton = () => {
  const cancelConfirmationButton = document.getElementById('order-unit-cancel-confirmation-button');
  const totalCount = ['adult', 'child', 'senior', 'student'].reduce((acc, personType) => {
    const peopleCountElement = document.getElementById(`order-unit-cancel-confirm-${personType}-count`) as HTMLSelectElement
    const peopleCount = peopleCountElement?.value || 0;
    return acc + Number(peopleCount);
  }, 0)
  if (totalCount === 0) {
    cancelConfirmationButton.style.pointerEvents = 'none'
    cancelConfirmationButton.classList.add('disabled');
  } else {
    activateCancelConfirmationButton();
  }
}

const handleCancelConfirmationButtonLink = () => {
  const adultCountElement = document.getElementById('order-unit-cancel-adult-count-select') as HTMLSelectElement
  const childCountElement = document.getElementById('order-unit-cancel-child-count-select') as HTMLSelectElement
  const seniorCountElement = document.getElementById('order-unit-cancel-senior-count-select') as HTMLSelectElement
  const studentCountElement = document.getElementById('order-unit-cancel-student-count-select') as HTMLSelectElement

  const params = {
    adult_count: adultCountElement?.value || '0',
    child_count: childCountElement?.value || '0',
    senior_count: seniorCountElement?.value || '0',
    student_count: studentCountElement?.value || '0'
  };
  const urlParams = new URLSearchParams(params);
  const cancelConfirmationButton = document.getElementById('order-unit-cancel-confirm') as HTMLAnchorElement
  const orderId = cancelConfirmationButton.dataset.orderId;
  const url = `/snow/me/orders/${orderId}/cancel_order_units?${urlParams.toString()}`;
  cancelConfirmationButton.href = url;
}
